import React from "react";
import { Modal } from "react-bootstrap";
import Resources from "../../../types/Resources";
import ChecklistRadioOptions from "../../Common/ChecklistRadioOptions";
import ScaffoldingChecklistFormState from "../../../types/forms/Permits/Conditions/ScaffoldingChecklistFormState";

type ScaffoldingChecklistModalProps = {
    resources: Resources;
    formState: ScaffoldingChecklistFormState;
    onChange: (fn: (prevValue: ScaffoldingChecklistFormState) => ScaffoldingChecklistFormState) => void;
    show: boolean;
    onHide: () => void;
    canManageContent: boolean;
};

function ScaffoldingChecklistModal({
    resources,
    formState,
    onChange,
    show,
    onHide,
    canManageContent
}: ScaffoldingChecklistModalProps) {
    function changeHandler(key: keyof ScaffoldingChecklistFormState, value: any) {
        onChange((prevValue) => {
            const formState: ScaffoldingChecklistFormState = {
                ...prevValue,
                [key]: {
                    ...prevValue[key],
                    value
                }
            };

            return formState;
        });
    }

    return (
        <Modal show={show} onHide={onHide} size="xl">
            <Modal.Header closeButton>
                <h1 className="h5">{resources.get("CheckListScaffolds")}</h1>
            </Modal.Header>
            <Modal.Body>
                <ul className="list-unstyled">
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="will-scaffolds-be-built-in-pumping-station"
                            labelText={resources.get("WillScaffoldsBeBuiltInPumpingStation")}
                            onChange={(updatedValue) =>
                                changeHandler("willScaffoldsBeBuiltInPumpingStation", updatedValue)
                            }
                            resources={resources}
                            value={formState.willScaffoldsBeBuiltInPumpingStation.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="is-harness-needed"
                            labelText={resources.get("IsHarnessNeeded")}
                            onChange={(updatedValue) => changeHandler("isHarnessNeeded", updatedValue)}
                            resources={resources}
                            value={formState.isHarnessNeeded.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="is-harness-inspected"
                            labelText={resources.get("IsHarnessInspected")}
                            onChange={(updatedValue) => changeHandler("isHarnessInspected", updatedValue)}
                            resources={resources}
                            value={formState.isHarnessInspected.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="is-connected-properly"
                            labelText={resources.get("IsConnectedProperly")}
                            onChange={(updatedValue) => changeHandler("isConnectedProperly", updatedValue)}
                            resources={resources}
                            value={formState.isConnectedProperly.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="is-scaffold-approved"
                            labelText={resources.get("IsScaffoldApproved")}
                            onChange={(updatedValue) => changeHandler("isScaffoldApproved", updatedValue)}
                            resources={resources}
                            value={formState.isScaffoldApproved.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="no-loose-planks-on-scaffold"
                            labelText={resources.get("NoLoosePlanksOnScaffold")}
                            onChange={(updatedValue) => changeHandler("noLoosePlanksOnScaffold", updatedValue)}
                            resources={resources}
                            value={formState.noLoosePlanksOnScaffold.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="is-there-risk-of-step-through"
                            labelText={resources.get("IsThereRiskOfStepThrough")}
                            onChange={(updatedValue) => changeHandler("isThereRiskOfStepThrough", updatedValue)}
                            resources={resources}
                            value={formState.isThereRiskOfStepThrough.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="is-ladder-higher-than-4-meters-and-back-protection"
                            labelText={resources.get("IsLadderHigherThan4MetersAndBackProtection")}
                            onChange={(updatedValue) =>
                                changeHandler("isLadderHigherThan4MetersAndBackProtection", updatedValue)
                            }
                            resources={resources}
                            value={formState.isLadderHigherThan4MetersAndBackProtection.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="are-escape-routes-cleared"
                            labelText={resources.get("AreEscapeRoutesCleared")}
                            onChange={(updatedValue) => changeHandler("areEscapeRoutesCleared", updatedValue)}
                            resources={resources}
                            value={formState.areEscapeRoutesCleared.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="does-scaffold-have-damage"
                            labelText={resources.get("DoesScaffoldHaveDamage")}
                            onChange={(updatedValue) => changeHandler("doesScaffoldHaveDamage", updatedValue)}
                            resources={resources}
                            value={formState.doesScaffoldHaveDamage.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="is-oil-spill-on-scaffold"
                            labelText={resources.get("IsOilSpillOnScaffold")}
                            onChange={(updatedValue) => changeHandler("isOilSpillOnScaffold", updatedValue)}
                            resources={resources}
                            value={formState.isOilSpillOnScaffold.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="is-ice-on-scaffold"
                            labelText={resources.get("IsIceOnScaffold")}
                            onChange={(updatedValue) => changeHandler("isIceOnScaffold", updatedValue)}
                            resources={resources}
                            value={formState.isIceOnScaffold.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="does-scaffolds-have-sufficient-railing"
                            labelText={resources.get("DoesScaffoldHaveSufficientRailing")}
                            onChange={(updatedValue) =>
                                changeHandler("doesScaffoldHaveSufficientRailing", updatedValue)
                            }
                            resources={resources}
                            value={formState.doesScaffoldHaveSufficientRailing.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="is-passage-affected-by-scaffold"
                            labelText={resources.get("IsPassageAffectedByScaffold")}
                            onChange={(updatedValue) => changeHandler("isPassageAffectedByScaffold", updatedValue)}
                            resources={resources}
                            value={formState.isPassageAffectedByScaffold.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-3">
                        <ChecklistRadioOptions
                            id="if-passage-affected-is-marked"
                            labelText={resources.get("IfPassageAffectedIsMarked")}
                            onChange={(updatedValue) => changeHandler("ifPassageAffectedIsMarked", updatedValue)}
                            resources={resources}
                            value={formState.ifPassageAffectedIsMarked.value}
                            readOnly={!canManageContent}
                        />
                    </li>
                </ul>
            </Modal.Body>
        </Modal>
    );
}

export default ScaffoldingChecklistModal;
